import { required, alpha_spaces, alpha } from "vee-validate/dist/rules";
import { extend } from "vee-validate";

extend("required", {
  ...required,
  message: "This field is required",
});

extend("alphaSpaces", {
  ...alpha_spaces,
  message: "This field must be  characters or spaces",
});
extend("alpha", {
  ...alpha,
  message: "This field must only contain alphabetic characters.",
});
